import React from 'react';
import './FormInput.css';

const DontsInput = ({ value, onChange }) => {
  return (
    <div className="form-input-group">
      <label className="form-label">Don'ts</label>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="form-textarea"
        placeholder="List constraints or things to avoid"
        rows="4"
      />
    </div>
  );
};

export default DontsInput;

